import { render, staticRenderFns } from "./msgGoods.vue?vue&type=template&id=74469f2d&scoped=true&"
import script from "./msgGoods.vue?vue&type=script&lang=js&"
export * from "./msgGoods.vue?vue&type=script&lang=js&"
import style0 from "./msgGoods.vue?vue&type=style&index=0&id=74469f2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74469f2d",
  null
  
)

export default component.exports